import { ZipperBDto } from "../dto/zipper-dto";
import { ZipperEntity } from "../entity/zipper-entity";

export class ZipperAdapter {
    public convertDtoToEntity(dto: ZipperBDto): ZipperEntity {
        const entity = new ZipperEntity()
        entity.id = dto.id;
        entity.style = dto.style;
        entity.size = dto.size;
        entity.consumption = dto.consumption; 
        if (dto.id) {
            entity.id = dto.id;
            entity.updatedUser = dto.createdUser;
        } else {
            entity.createdUser = dto.createdUser;
        }
        return entity
    }


    public convertEntityToDto(entity: ZipperEntity): ZipperBDto {
        const dto = new ZipperBDto()
        dto.id = entity.id;
        dto.style = entity.style;
        dto.size = entity.size;
        dto.consumption = entity.consumption;
        dto.createdAt = entity.createdAt
        dto.updatedAt = entity.updatedAt
        dto.updatedUser = entity.updatedUser
        dto.isActive = entity.isActive;
        dto.versionFlag = entity.versionFlag;
       
        return dto
    }

}